import { useRef, useEffect } from "react";
import "./MotorSlider.css";

const MotorSlider = ({ value, setValue }) => {
  const sliderElem = useRef(null);

  useEffect(() => {
    if (sliderElem.current && !sliderElem.current.noUiSlider) {
      // ایجاد اسلایدر noUiSlider
      window.noUiSlider.create(sliderElem.current, {
        start: [0, value > 20 ? value - 256 : value], // مقدار اول همیشه 0 است
        behaviour: "unconstrained",
        connect: true,
        tooltips: true,
        step: 1,
        format: {
          from: function (formattedValue) {
            return parseInt(formattedValue);
          },
          to: function (numericValue) {
            return parseInt(numericValue);
          },
        },
        range: {
          min: -20,
          max: 20,
        },
      });

      // بروز رسانی مقدار اسلایدر دوم وقتی مقدار تغییر کند
      sliderElem.current.noUiSlider.on("set", (values) => {
        setValue(Number(values[1])); // مقدار دوم را تنظیم کنید
      });

      // افزودن رویداد mousedown برای تغییر مقدار اسلایدر دوم
      sliderElem.current.parentElement.addEventListener(
        "mousedown",
        function (e) {
          const rect = sliderElem.current.getBoundingClientRect();
          const clickPosition = e.clientX - rect.left;
          const clickPercentage = (clickPosition / rect.width) * 100;

          const newValue =
            sliderElem.current.noUiSlider.options.range.min +
            (clickPercentage / 100) *
              (sliderElem.current.noUiSlider.options.range.max -
                sliderElem.current.noUiSlider.options.range.min);

          // فقط مقدار دوم (انتها) را تغییر دهید و مقدار اول را همیشه صفر نگه دارید
          sliderElem.current.noUiSlider.set([0, newValue]);
          setValue(Number(newValue));
        }
      );
    }
  }, [value]);

  useEffect(() => {
    // بروز رسانی مقدار اسلایدر دوم وقتی prop تغییر کند
    if (sliderElem.current && sliderElem.current.noUiSlider) {
      sliderElem.current.noUiSlider.set([0, value > 20 ? value - 256 : value]); // مقدار اول همیشه 0
    }
  }, [value]);

  return (
    <div className="slider-container">
      <div ref={sliderElem} className="my-4"></div>
    </div>
  );
};

export default MotorSlider;
